import React, { Fragment } from 'react';
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    FormFeedback,
    FormGroup,
    FormText,
    Input,
    Label,
    Row
} from 'reactstrap';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { useConfigExams } from '../../../hooks/maquilaInterna/useConfigExams';
import { SearchAsync } from '../../../components/elements/SearchAsync';

import './styleConfigExams.css';

export const IndexConfigExams = () => {

    const {

        branchInformation,
        examsMaquila,
        branchList,

        searchExamState,
        validationExams,

        handleSelectExamChange,
        handleInputChange,
        handleDelete,
        handleSaveOrUpdate

    } = useConfigExams();

    const {
        validBranch,
        listBranch
    } = validationExams;


    const branchTemplate = (rowData) => {

        return (

            <FormGroup className='mb-0'>

                <Input
                    type='select'
                    className="inputModernConfig"
                    value={rowData.id_branch_destination}
                    invalid={rowData.valid}
                    onChange={(e) =>
                        handleInputChange(e, rowData.id_exam)
                    }
                >

                    <option value={'0'}>
                        Selecciona una opción
                    </option>

                    {
                        branchList.length > 0 &&
                        branchList.map((branch, branchIndex) => (

                            <option
                                value={branch.id_branch}
                                key={`optionIndex-${branchIndex}`}
                            >
                                {branch.name}
                            </option>
                        ))
                    }

                </Input>

                <FormFeedback>
                    Selecciona una opción
                </FormFeedback>

            </FormGroup>
        );
    };


    const actionTemplate = (rowData) => {

        return (

            <div className='text-center'>

                <Button
                    className='btnDeleteExam'
                    onClick={() =>
                        handleDelete(
                            rowData.id_branch,
                            rowData.id_branch_destination,
                            rowData.id_exam
                        )
                    }
                >

                    <i className="icofont icofont-trash"></i>

                </Button>

            </div>
        );
    };


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };
    return (

        <Fragment>

            <Container fluid={true}>
                <div className='container-global-zoom'>
                     <Row className='g-3'>

                        <Col xl="3" lg="4" md="12">

                            <Card className='cardConfigExam shadow-sm border-0'>

                                <CardBody className='p-3'>

                                    <div className='headerConfigExam'>

                                        <div className='iconConfigExam'>
                                            <i className="icofont icofont-building-alt"></i>
                                        </div>

                                        <div>

                                            <h5 className='titleConfigExam'>
                                                Origen
                                            </h5>

                                            <small className='text-muted'>
                                                Sucursal principal
                                            </small>

                                        </div>

                                    </div>


                                    <div className='branchInfoCard'>

                                        <div className='branchNameConfig'>

                                            {
                                                branchInformation.name_branch
                                            }

                                        </div>

                                    </div>


                                    <div className='mt-3'>

                                        <Label className='labelConfigExam'>
                                            Búsqueda de exámenes
                                        </Label>

                                        <SearchAsync
                                            loincState={searchExamState}
                                            name="id_search_exam"
                                            method={handleSelectExamChange}
                                            url="Profiles/SearchProfileExam"
                                            maxLenght={3}
                                        />

                                        <FormText
                                            color='danger'
                                            hidden={!listBranch}
                                        >
                                            Debes seleccionar al menos un examen
                                        </FormText>

                                    </div>


                                    <Button
                                        className='btnSaveConfigExam mt-3'
                                        onClick={handleSaveOrUpdate}
                                    >

                                        <i className='fa fa-save'></i>

                                        <span className='ms-2'>
                                            Guardar cambios
                                        </span>

                                    </Button>

                                </CardBody>

                            </Card>

                        </Col>


                        <Col xl="9" lg="8" md="12">

                            <Card className='cardConfigExam shadow-sm border-0'>

                                <CardBody className='p-3'>

                                    <div className='tableHeaderConfig'>

                                        <div>

                                            <h5 className='titleConfigExam mb-0'>
                                                Estudios a maquilar
                                            </h5>

                                            <small className='text-muted'>
                                                Configuración de maquila interna
                                            </small>

                                        </div>

                                    </div>


                                    {
                                        examsMaquila.length === 0
                                            ?
                                            <div className='emptyConfigExam'>

                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    alt=""
                                                    className='imgEmptyConfig'
                                                />

                                                <label className='badgeEmptyConfig'>
                                                    No se ha registrado ningún estudio
                                                </label>

                                            </div>
                                            :
                                            <>

                                                <FormText
                                                    color='danger'
                                                    hidden={!validBranch}
                                                >
                                                    Falta seleccionar una sucursal
                                                </FormText>


                                                <DataTable
                                                    value={examsMaquila}
                                                    responsiveLayout="scroll"
                                                    paginator
                                                    rows={10}
                                                    stripedRows
                                                    emptyMessage="No se encontraron estudios"
                                                    className="data-table p-datatable-striped p-datatable-sm"
                                                >   
                                                    <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />

                                                    <Column
                                                        field="code"
                                                        header="Código"
                                                        headerStyle={headerStyle}
                                                        style={cellStyle}
                                                    />

                                                    <Column
                                                        field="name"
                                                        header="Descripción"
                                                        headerStyle={headerStyle}
                                                        style={cellStyle}
                                                    />

                                                    <Column
                                                        header="Sucursal a maquilar"
                                                        body={branchTemplate}
                                                        headerStyle={headerStyle}
                                                        style={cellStyle}
                                                    />

                                                    <Column
                                                        header="Acciones"
                                                        body={actionTemplate}
                                                    headerStyle={headerStyle}
                                                        style={cellStyle}
                                                    />

                                                </DataTable>

                                            </>
                                    }

                                </CardBody>

                            </Card>

                        </Col>

                    </Row>
                    
                </div>

               

            </Container>

        </Fragment>
    )
}